<template>
  <div class="columns">
    <!-- 客户样本编号-->
    <el-table-column label="样本条码号" prop="sampleId" min-width="110" v-if="isShow('样本条码号')">
    </el-table-column>
    <el-table-column label="生产条码号" prop="labCode" min-width="110" v-if="isShow('生产条码号')">
    </el-table-column>
    <el-table-column label="采集日期" prop="sampleId" min-width="90" v-if="isShow('采集日期')">
      <template slot-scope="scope">
        {{scope.row.currentSample.collectTime ? formatDate(scope.row.currentSample.collectTime) :''}}
      </template>
    </el-table-column>
    <el-table-column label="采集次数" prop="collectTimes" min-width="110" v-if="isShow('采集次数')">
      <template slot-scope="scope">
        {{scope.row.collectTimes!==null ? `第${scope.row.collectTimes}次` :''}}
      </template>
    </el-table-column>
    <el-table-column label="接收日期" prop="sampleId" min-width="90" v-if="isShow('接收日期')">
      <template slot-scope="scope">
        {{scope.row.otherInfo.SampleReceiveTime ? formatDate(scope.row.otherInfo.SampleReceiveTime) :''}}
      </template>
    </el-table-column>
    <el-table-column label="运输日期" min-width="110" v-if="isShow('运输日期')">
      <template slot-scope="scope">
        {{formatDate(scope.row.samplesSentToCheckDate)}}
      </template>
    </el-table-column>
    <el-table-column label="受检人" prop="patient.name" min-width="70" v-if="isShow('受检人')"></el-table-column>
    <el-table-column label="性别" min-width="60" v-if="isShow('性别')">
      <template slot-scope="scope">
        {{scope.row.patient.gender ? genderFormat(scope.row.patient.gender) : ''}}
      </template>
    </el-table-column>
    <el-table-column label="年龄" min-width="60" v-if="isShow('年龄')">
      <template slot-scope="scope">
        {{scope.row.patient.birthday || scope.row.patient.age ?  scope.row.patient.age || birthdayToAge(scope.row.patient.birthday) : ''}}
      </template>
    </el-table-column>
    <el-table-column label="受检者姓名" prop="patient.name" min-width="70" v-if="isShow('受检者姓名')"></el-table-column>
    <el-table-column label="受检者性别" min-width="60" v-if="isShow('受检者性别')">
      <template slot-scope="scope">
        {{scope.row.patient.gender ? genderFormat(scope.row.patient.gender) : ''}}
      </template>
    </el-table-column>
    <el-table-column label="受检者年龄" min-width="60" v-if="isShow('受检者年龄')">
      <template slot-scope="scope">
        {{scope.row.patient.birthday || scope.row.patient.age ?  scope.row.patient.age || birthdayToAge(scope.row.patient.birthday) : ''}}
      </template>
    </el-table-column>
    <el-table-column label="样本类型" prop="sampleId" min-width="90" v-if="isShow('样本类型')">
      <template slot-scope="scope">
        {{scope.row.currentSample ? getEnumeration(scope.row.currentSample.sampleType, sampleType) : ''}}
      </template>
    </el-table-column>
    <el-table-column label="商品名称" prop="detectionPackageNames" min-width="145" v-if="isShow('商品名称')"></el-table-column>
    <el-table-column label="待操作状态" prop="sampleId" min-width="90" v-if="isShow('待操作状态')">
      <template slot-scope="scope">
        <!-- <span v-if="scope.row.pedingApproval" class="red">待审批</span> -->
        <span v-if="scope.row.orderStatusEnum=='LAB_SAMPLE_RETURNED'">{{'样本重采'}}</span>
        <span v-if="scope.row.orderStatusEnum=='CLOSED'">{{'已关闭'}}</span>
        <span v-else>{{orderFlowHelper.formatOrderActions(scope.row.nextOrderAction,isAdult)}}</span>
      </template>
    </el-table-column>
    <el-table-column label="手机号" prop="patient.reportReceiverMobile" min-width="110" v-if="isShow('手机号')">
    </el-table-column>
    <el-table-column label="证件号" min-width="110" v-if="isShow('证件号')" prop="patient.identityCard">
    </el-table-column>
    <el-table-column label="检测套餐" prop="detectionPackageNames" min-width="145" v-if="isShow('检测套餐')"></el-table-column>
    <el-table-column label="实验室检测平台" prop="product.name" min-width="120" v-if="isShow('实验室检测平台')"></el-table-column>
    <!-- 订单来源 -->
    <el-table-column label="订单来源" prop="salesFrom" min-width="100" v-if="isShow('订单来源')">
      <template slot-scope="scope">
        {{formatSaleFrom(scope.row.salesFrom)}}
      </template>
    </el-table-column>
    <el-table-column label="订单类型" min-width="100" v-if="isShow('订单类型')">
      <template slot-scope="scope">
        {{scope.row.workflow==='REPORT_ONLY_UNLOCK'?'解锁订单':'购买订单'}}
      </template>
    </el-table-column>
    <el-table-column label="地区" prop="otherInfo.businessOriginArea" min-width="70" v-if="isShow('地区')">
    </el-table-column>
    <el-table-column label="订单号" prop="otherInfo.mallOrderNumber" min-width="180" v-if="isShow('订单号')">
    </el-table-column>
    <el-table-column label="订单内容" prop="otherInfo.mallOrderName" min-width="100" v-if="isShow('订单内容')">
    </el-table-column>
    <el-table-column label="交付日期" prop="" min-width="100" v-if="isShow('交付日期')">
      <template slot-scope="scope">
        {{formatDate(scope.row.expectedDeliveryDate)}}
      </template>
    </el-table-column>
    <el-table-column label="剩余天数" min-width="90" prop="" v-if="isShow('剩余天数')">
      <template slot-scope="scope" >
        <span v-if="scope.row.remainingDays !==null && scope.row.orderStatusEnum!='COMPLETED' &&  scope.row.orderStatusEnum!='CLOSED'">{{scope.row.remainingDays + ' ' + (scope.row.product.dayType ? getDayTypes(scope.row.product.dayType) :'')}}</span>
        <p v-else>--</p>
      </template>
      <!-- <template slot-scope="scope">
        <span
          v-if="scope.row.orderStatusEnum!='COMPLETED' &&  scope.row.orderStatusEnum!='CLOSED'">{{scope.row.remainingDays}}</span>
        <p v-else>--</p>
      </template> -->
    </el-table-column>
    <el-table-column label="待操作" prop="orderStatusEnum" min-width="90" v-if="isShow('待操作')">
      <template slot-scope="scope">
        <!-- <span v-if="scope.row.pedingApproval" class="red">待审批</span> -->
        <span v-if="scope.row.orderStatusEnum=='LAB_SAMPLE_RETURNED'">{{'样本重采'}}</span>
        <span v-if="scope.row.orderStatusEnum=='CLOSED'">{{'已关闭'}}</span>
        <span v-else>{{orderFlowHelper.formatOrderActions(scope.row.nextOrderAction)}}</span>
      </template>
    </el-table-column>
    <el-table-column label="历史检测" prop="" v-if="isShow('历史检测')">
      <template slot-scope="scope">
        <!-- <router-link target="_blank" v-if="scope.row.historyOrders" :to="{ path: `/lab-order-detail/${scope.row.historyOrders[scope.row.historyOrders.length-1].id}` }">
      <a style="color:#EDBE7C">{{scope.row.historyOrders[scope.row.historyOrders.length-1].sampleId}}</a>
      </router-link> -->
        <span
          style="color:#EDBE7C">{{scope.row.historyOrders && scope.row.historyOrders.length ? scope.row.historyOrders.length :'无'}}</span>
      </template>
    </el-table-column>
    <el-table-column label="生产条码号" width="280" v-if="isShow('生产条码号_input')">
      <template slot-scope="scope">
        <el-input @change="labCodeChange(scope.row)" v-model="scope.row.labCode" @keydown.enter.native="getBlur"
          v-focus="getFocus" @mousedown.stop.native @click.stop.native class="specical-input"></el-input>
        <el-button v-if="showCopy" type="text" @click="copySampleId(scope.row)">复制</el-button>
      </template>
    </el-table-column>
  </div>
</template>

<script>
import {
  sampleType
} from 'json/goods-order-options'
import {
  getEnumeration
} from 'enumeration'
import {
  formatDate,
  genderFormat,
  birthdayToAge
} from '@/utils/formUtils'
import {
  formatSaleFrom
} from 'enumeration/lab-order'
import { getDayTypes } from 'enumeration/mall.js'
import orderFlow from '@/config/order'
export default {
  props: {
    showFields: {
      type: Array,
      default: () => []
    },
    getFocus: {
      type: Boolean,
      default: false
    },
    showCopy: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      sampleType: sampleType,
      orderFlowHelper: orderFlow
    }
  },
  computed: {
    isAdult () {
      let isAdult = (this.$route.name === 'adult-sell-order' || this.$route.query.isAdult)
      return isAdult
    }
  },
  methods: {
    formatDate,
    genderFormat,
    birthdayToAge,
    getEnumeration,
    formatSaleFrom,
    getDayTypes,
    getBlur (e) {
      this.$emit('updateFocus', true)
      e.target.blur()
    },
    isShow (label) {
      return this.showFields.indexOf(label) > -1
    },
    labCodeChange (val) {
      this.$emit('updateLabcode', val)
    },
    copySampleId (data) {
      data.labCode = data.sampleId
    }
  }
}

</script>

<style lang="less">
  .specical-input.el-input {
    max-width: 200px;

    .el-input__inner {
      border: none;
      padding-left: 0;
      padding-right: 0;
      outline: none;
      transition: none;
      background-color: transparent;

      &:focus {
        border: 1px solid #dcdfe6;
        background-color: #fff;
      }
    }
  }

</style>
